import { getUserGroups } from "../../../../../djelatnikProfil/api/getUserGroups";
import { getUserData } from "./api/getUserData";

export const questionMappingOR = {
  questionOr1: "Opiši svoje trenutno radno mjesto",
  questionOr2:
    "Navedi ako imaš dosadašnje iskustvo u savjetodavnim, psihoterapijskim ili sličnim edukacijama za rad s ljudima kao i u neposrednom stručnom radu s ljudima.",
  questionOr3:
    "Navedi ako imaš svoja osobna iskustva u radu na sebi i psihoterapiji.",
  questionOr4: "Opiši kratko što je tvoja motivacija za upis OR-a.",
  questionOr5:
    "Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje.",
  checkOr1:
    "Ovime potvrđujem da nemam trenutno nikakvo fizičko ili psiho-emocionalno stanje koje bi moglo biti u kontraindikaciji s programom Osobni razvoj.U slučaju da se pitaš da li je neko tvoje fizičko ili psiho-emocionalno stanje ili neki lijekovi koje uzimaš u kontraindikaciji sa upisom OR-a javi nam se na referada@ipd-center.eu kako bi dogovorili evaluacijsku terapiju s voditeljem grupe OR-a.",
  checkOr2:
    "Ovime potvrđujem da u ovoj fazi života (ukoliko ne dođe do nekih nepredviđenih okolnosti) sam u mogućnosti financirati pohađanje programa četverogodišnji Osobni razvoj i potrebne individualne terapije",
};

export const questionMappingEOR = {
  question1: "Opiši svoje trenutno radno mjesto",
  question2:
    "Navedi ako imaš dosadašnje iskustvo u savjetodavnim, psihoterapijskim ili sličnim edukacijama za rad s ljudima kao i u neposrednom stručnom radu s ljudima:",
  question3:
    "Navedi ako imaš svoja osobna iskustva u radu na sebi i psihoterapiji.",
  question4: "Opiši kratko što je tvoja motivacija za upis eOR-a.",
  choice:
    "Da li je tvoja namjera dolaziti 1x godišnje na modul uživo u Zagreb?",
  question5:
    "Da li već sada znaš da namjeravaš upisati trening za psihoterapeute ITP-a koji počinje na 3. godini s programom TP i nastavlja se na petoj i šestoj godini s programom TT.",
  question6:
    "Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje",
  check1:
    "Ovime potvrđujem da nemam trenutno nikakvo fizičko ili psiho-emocionalno stanje koje bi moglo biti u kontraindikaciji s programom Osobni razvoj.U slučaju da se pitaš da li je neko tvoje fizičko ili psiho-emocionalno stanje ili neki lijekovi koje uzimaš u kontraindikaciji sa upisom OR-a javi nam se na referada@ipd-center.eu kako bi dogovorili evaluacijsku terapiju s voditeljem grupe OR-a.",
  check2:
    "Ovime potvrđujem da u ovoj fazi života (ukoliko ne dođe do nekih nepredviđenih okolnosti) sam u mogućnosti financirati pohađanje programa četverogodišnji Osobni razvoj i potrebne individualne terapije",
};

export const questionMappingTP1 = {
  evidentionOR1Lessons: "1. godina OR - broj predavanja",
  evidentionOR1Workshops: "1. godina OR - broj radionica",
  evidentionOR2Lessons: "2. godina OR - broj predavanja",
  evidentionOR2Workshops: "2. godina OR - broj radionica",
  evidentionEOR1Lessons: "1. godina eOR - broj predavanja",
  evidentionEOR1Workshops: "1. godina eOR - broj radionica",
  evidentionEOR1LiveModule: "1. godina eOR - broj Modula uživo",
  evidentionEOR2Lessons: "2. godina eOR - broj predavanja",
  evidentionEOR2Workshops: "2. godina eOR - broj radionica",
  evidentionEOR2LiveModule: "2. godina eOR - broj Modula uživo",
  checkOneTP1:
    "Potvrđujem da sam u Moj profil pohranio skeniranu potvrdu o nekažnjavanju u kojoj je vidljivo da nisam pravomoćno osuđen/a za neko od kaznenih djela navedenih u Zakonu o djelatnosti psihoterapije.",
  questionOneTP1:
    "Navedi ako imaš dodatne edukacije iz područja psihoterapije ili nekog sličnog rada na sebi.",
  choiceOneTP1:
    "Imaš li riješene sve financijske obaveze prema školi od prethodnih godina što je preduvjet za upis TP1?",
  choiceTwoTP1:
    "Uvjet za upis TP1 su ispunjene sve introspekcije do zadnjeg predavanja OR-a koje si imao/la. Imaš li ispunjene sve introspekcije do sada?",
  questionTwoTP1:
    "Uvjet za upis u TP1 je min 24 sata programskih terapija (IPR-a). Broj tvojih programskih terapija do današnjeg datuma unesenih u školski sustav:",
  questionThreeTP1:
    "Ako si dobio/la uvjetan upis u TP1 (naknadno ispunjavanje uvjeta za terapije koje ti nedostaju) napiši broj terapija koje ti nedostaju i do kojeg datuma ti je mentor dao da ispuniš uvjete.",
  questionFourTP1:
    "Opiši: kako sada vidiš svoje trenutne kapacitete da budeš na TP-u, što misliš sada na čemu trebaš raditi kod sebe kako bi na TP2 mogao/la početi raditi s ljudima:",
  questionFiveTP1:
    "Opiši zašto želiš upisati TP, što je tvoja motivacija da budeš terapeut:",
  choiceThreeTP1:
    "Označi u kojoj grupi bi želio/željela pohađati radionice TP1 (napomena: Termini grupa (radionica TP1) za koje se trebaš odlučiti su ti dostavljeni u e-mailu. Škola ne garantira da ćeš u željenom terminu pohađati TP1 pa je važno da odabereš i alternativni termin/grupu. Nakon što završe prijave i oforme se grupe, potvrdit ćemo ti s kojom grupom ćeš pohađati TP shodno mogućnostima i broju prijava)",
  selectOneTP1:
    "U slučaju da će neke grupe biti popunjene i neki će morati prijeći u druge grupe navedi koja bi ti alternativna grupa odgovarala:",
  choiceFourTP1: "Upisani TP1 program plaćam kao:",
  questionSixTP1:
    "Kao firma iz Hrvatske navodim adresu, grad i državu sjedišta firme i oib firme:",
  questionSevenTP1:
    "Kao firma iz drugih država (osim Hrvatske) navodim adresu, grad i državu sjedišta firme i važeći vat broj firme iz eu (u slučaju da nemate važeći VAT broj, račun smo obavezni izdati na ime i prezime polaznika sukladno članku 196. direktive vijeća 2006/112/ez i članku 75. stavka 1. točke 6. zakona o porezu na dodanu vrijednost):",
  questionEightTP1:
    "Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje:",
};
export const questionMappingTP2 = {
  TP2EvidentionOR1Lessons: "1. godina OR - broj predavanja",
  TP2EvidentionOR1Workshops: "1. godina OR - broj radionica",
  TP2EvidentionOR2Lessons: "2. godina OR - broj predavanja",
  TP2EvidentionOR2Workshops: "2. godina OR - broj radionica",
  TP2EvidentionOR3Lessons: "3. godina OR - broj predavanja",
  TP2EvidentionOR3Workshops: "3. godina OR - broj radionica",
  TP2EvidentionEOR1Lessons: "1. godina eOR - broj predavanja",
  TP2EvidentionEOR1Workshops: "1. godina eOR - broj radionica",
  TP2EvidentionEOR1LiveModule: "1. godina eOR - broj Modula uživo",
  TP2EvidentionEOR2Lessons: "2. godina eOR - broj predavanja",
  TP2EvidentionEOR2Workshops: "2. godina eOR - broj radionica",
  TP2EvidentionEOR2LiveModule: "2. godina eOR - broj Modula uživo",
  TP2EvidentionEOR3Lessons: "3. godina eOR - broj predavanja",
  TP2EvidentionEOR3Workshops: "3. godina eOR - broj radionica",
  TP2EvidentionEOR3LiveModule: "3. godina eOR - broj Modula uživo",
  checkOneTP2:
    "Potvrđujem da sam u Moj profil pohranio skeniranu potvrdu o nekažnjavanju u kojoj je vidljivo da nisam pravomoćno osuđen/a za neko od kaznenih djela navedenih u Zakonu o djelatnosti psihoterapije.",
  choiceOneTP2:
    "Imaš li riješene sve financijske obaveze prema školi od prethodnih godina što je preduvjet za upis TP2?",
  choiceTwoTP2:
    "Uvjet za upis TP2 su ispunjene sve introspekcije do zadnjeg predavanja TP1 koje si imao/la. Imaš li ispunjene sve introspekcije do sada?",
  questionTwoTP2:
    "Uvjet za upis u TP2 je min 40 sati programskih terapija (IPR-a). Broj tvojih programskih terapija do današnjeg datuma unesenih u školski sustav:",
  questionThreeTP2:
    "Ako si dobio/la uvjetan upis u TP2 (naknadno ispunjavanje uvjeta za terapije koje ti nedostaju) napiši broj terapija koje ti nedostaju i do kojeg datuma ti je mentor dao da ispuniš uvjete.",
  evidentionTRIJADA: "Trijada",
  evidentionAGS: "AGS",
  evidentionEPER: "EPeR",
  choiceThreeTP2: "Upisani TP2 program plaćam kao:",
  questionFourTP2:
    "Kao firma iz Hrvatske navodim adresu, grad i državu sjedišta firme i oib firme:",
  questionFiveTP2:
    "Kao firma iz drugih država (osim Hrvatske) navodim adresu, grad i državu sjedišta firme i važeći vat broj firme iz eu (u slučaju da nemate važeći VAT broj, račun smo obavezni izdati na ime i prezime polaznika sukladno članku 196. direktive vijeća 2006/112/ez i članku 75. stavka 1. točke 6. zakona o porezu na dodanu vrijednost):",
  questionSixTP2:
    "Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje:",
};

export const questionMappingTT = {
  TTEvidentionIPRHours: "Broj sati IPR-a (programskih terapija, min 60 sati):",
  TTEvidentionGPRHours:
    "Broj sati GPR-a (grupnog psihoterapijskog rada, min 90 sati):",
  TTEvidentionIndividualSupervisions:
    "Broj sati individualnih supervizija (1na1 ili izlagač na AGS-u, min 15 sati):",
  TTEvidentionGroupSupervisions: "Broj sati grupne supervizije:",
  TTWorkWithClientsHours: "Broj sati rada s klijentima (min 20 sati)",
  TTSupervisorApproval: "Potvrda o radu s klijentima",
  TTZavrsniOR: "Napisan Završni rad OR-a",
  TTCaseStudyOne: "Obranjena Studija slučaja 1 (CS1)",
  selectOneTT:
    "Ako nemaš sve ispunjene uvjete označi do kada planiraš ispuniti sve navedene uvjete i izaći na obranu CS1? (odaberu jednu od opcija)",
  checkOneTT:
    "Potvrđujem da primam na znanje da Škola ITP-a dodjeljuje diplomu prema uvjetima koje propisuju EAP i EABP te da su nosioci diplome dužni svoje zvanje i legalnost rada prilagoditi zakonima ili propisima o djelatnosti psihoterapije koji vrijede u državi u kojoj žele raditi.",
  checkTwoTT:
    "Potvrđujem da sam upoznat sa Zakonom o djelatnosti psihoterapije u Hrvatskoj koji kaže: Djelatnost psihoterapije obavlja ovlašteni psihoterapeut ili ovlašteni savjetodavni terapeut. Za status savjetodavnog terapeuta potrebno je imati minimalno status Sveučilišnog prvostupnika (Baccalaureus) stručnog prvostupnik ili VŠS (prije Bologne) i uz to imati završenu Propedeutiku psihoterapije. Za status psihoterapeuta neki od navedenih fakulteta (medicinske znanosti, kliničke medicinske znanosti, javnog zdravstva i zdravstvene zaštite, psihologije, socijalne djelatnosti, edukacijsko-rehabilitacijske znanosti, pedagogije i logopedije)",
  checkThreeTT:
    "U većini zemalja (Srbija, Slovenija, BiH, S. Makedonija, Crna Gora i mnoge druge zemlje, djelatnost psihoterapije još nije regulirana zakonski, ali primam na znanje da sam obavezan/na svoj terapeutski rad i svoje predstavljanje prilagoditi postojećim propisima u zemlji u kojoj namjeravam raditi.",
};
export const questionMappings = {
  OR: questionMappingOR,
  eOR: questionMappingEOR,
  TP1: questionMappingTP1,
  TP2: questionMappingTP2,
  TT: questionMappingTT,
};

export const attendanceMappingTP1 = {
  evidentionOR1Lessons: 6,
  evidentionOR1Workshops: 17,
  evidentionOR2Lessons: 6,
  evidentionOR2Workshops: 17,
  evidentionEOR1Lessons: 6,
  evidentionEOR1Workshops: 14,
  evidentionEOR1LiveModule: 5,
  evidentionEOR2Lessons: 6,
  evidentionEOR2Workshops: 14,
  evidentionEOR2LiveModule: 5,
  questionTwoTP1: 24,
};
export const attendanceMappingTP2 = {
  TP2EvidentionOR1Lessons: 6,
  TP2EvidentionOR1Workshops: 17,
  TP2EvidentionOR2Lessons: 6,
  TP2EvidentionOR2Workshops: 17,
  TP2EvidentionOR3Lessons: 6,
  TP2EvidentionOR3Workshops: 17,
  TP2EvidentionEOR1Lessons: 6,
  TP2EvidentionEOR1Workshops: 14,
  TP2EvidentionEOR1LiveModule: 5,
  TP2EvidentionEOR2Lessons: 6,
  TP2EvidentionEOR2Workshops: 14,
  TP2EvidentionEOR2LiveModule: 5,
  TP2EvidentionEOR3Lessons: 6,
  TP2EvidentionEOR3Workshops: 14,
  TP2EvidentionEOR3LiveModule: 5,
  questionTwoTP2: 40,
  evidentionTRIJADA: 15,
  evidentionAGS: 9,
  evidentionEPER: 6,
};

export const attendanceMappingTT = {
  TTEvidentionIPRHours: 60,
  TTEvidentionGPRHours: 90,
  TTEvidentionIndividualSupervisions: 15,
  TTWorkWithClientsHours: 20,
};
export const fetchGroupData = async (userData, authToken, setUserGroups) => {
  try {
    const response = await getUserGroups(userData, authToken);
    const activeGroups = response.groups.filter((group) => !group.isArchived);
    const groupsAllowedByReferada = activeGroups.filter(
      (group) => group.showProgramApplications
    );
    return groupsAllowedByReferada;
  } catch (error) {
    console.error("Error fetching group data:", error);
  }
};

export const programGroups = {
  OR: "RAR",
  eOR: "eRAR",
  TP1: "OR",
  TP2: "TP1",
  TT: "TP2",
};

export const mentorProgramIdsMapping = {
  1: [3],
  2: [7],
  4: [13],
  5: [13],
  6: [13],
  13: [14],
  14: [11, 12],
};
export const getPreviousGroupCourse = (course) => {
  return programGroups[course] || "Nema podataka";
};

export const fetchUser = async (
  evidentionUserID,
  setLoading,
  accessToken,
  setUserData,
  course,
  setGroup
) => {
  if (evidentionUserID) {
    try {
      setLoading(true);
      const response = await getUserData(evidentionUserID, accessToken);
      setUserData(response);
      if (response?.data?.aktivnaGrupa) {
        const seenGroups = new Set();
        const previousCourse = getPreviousGroupCourse(course);
        const groupData = response?.data?.aktivnaGrupa.find((group) => {
          const isMatch = group?.name.includes(previousCourse);
          const isNew = !seenGroups.has(group?.name);
          if (isMatch && isNew) {
            seenGroups.add(group?.name);
            return true;
          }
          return false;
        });
        setGroup(groupData);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setLoading(false);
    }
  }
};

export function getCourseContext(course, data) {
  const {
    userId,
    application,
    commentModal,
    evidentionUserID,
    fetchApplicationCallback,
    programApplicationId,
    authToken,
    setApplication,
    setVisibleForm,
    formMethodsOne,
    formMethodsTwo,
    formMethodsThree,
    formMethodsFour,
  } = data;

  return {
    userId,
    application,
    commentModal,
    course,
    evidentionUserID,
    fetchApplicationCallback: async () => {
      fetchApplicationCallback(
        programApplicationId,
        authToken,
        setApplication,
        setVisibleForm,
        formMethodsOne,
        formMethodsTwo,
        formMethodsThree,
        formMethodsFour
      );
    },
  };
}
